import React                  from "react";
import { useDispatch }        from 'react-redux';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';
import { faPlusCircle }       from '@fortawesome/free-solid-svg-icons';
import { faMinusCircle }       from '@fortawesome/free-solid-svg-icons';

import {
  changeBomName,
  changeBomRevision,
  changeBomBoardQty,
  changeBomHeader,
  changeBomFirstRow,
  addBomBoardQty,
  removeLastBomBoardQty,
} from '../../../bomSlice';

const BomForm = (props) => {
  const dispatch = useDispatch()
  
  const {
    board_qtys,
    header,
    first_row,
    validator,
  } = props

  const onChangeBoardQty = (index, board_qty) => {
    dispatch(changeBomBoardQty({ index, board_qty }))
  }

  const onChangeBomHeader = (header) => {
    dispatch(changeBomHeader(header))
  }

  const onChangeBomFirstRow = (first_row) => {
    dispatch(changeBomFirstRow(first_row))
  }

  const onAddBoardQty = () => {
    if(board_qtys && board_qtys.length < 4) dispatch(addBomBoardQty({ board_qty: null }))
  }

  const onRemoveLastBoardQty = () => {
    if(board_qtys && board_qtys.length > 1) dispatch(removeLastBomBoardQty())
  }

  return (
    <>
      <div className="row">
        <div className="col-sm-5"/>
        <div className="col-sm-2"><label>IDENTIFY ROW:</label></div>
        <div className="col-sm-5"/>
        <div className="col-sm-5">
          <div className="">
            <label htmlFor="bom_board_qtys">BOARD QUANTITY</label><br/>
            <div className="content-board-qty">
              <div className="inputs">
                { board_qtys && board_qtys.map((board_qty, index) => (
                  <div key={`board_qty_${index}`}>
                    <input key={`board_qty_${index}`} className="form-control board_qty_input" type="text" 
                      name={`board_qty[${index + 1}]`} 
                      value={board_qty || ""}
                      onChange={(e) => onChangeBoardQty(index, e.target.value)}/>
                    {validator && validator.message(`Board Quantity`, board_qty, 'required|numeric|min:1,num')}
                  </div>
                )) }
              </div>
              <div className="controls">
                <FontAwesomeIcon icon={faPlusCircle} id="add_board_qty" onClick={onAddBoardQty}/>
                <FontAwesomeIcon icon={faMinusCircle} id="minus_board_qty" onClick={onRemoveLastBoardQty}/>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="">
            <label>HEADER ROW</label><br/>
            <input className="form-control" type="number" min="1" name="header" id="bom_header"
              data-label="HEADER" data-class="header" 
              value={header || ""}
              onChange={(e) => onChangeBomHeader(e.target.value)}/>
            {validator && validator.message(`Header Row`, header, 'required|numeric|min:1,num')}
          </div>
        </div>
        <div className="col-sm-2">
          <div className="">
            <label>1ST DATA ROW</label><br/>
            <input className="form-control" type="number" min="1" name="first_row" id="bom_first_row"
              data-label="1st DATA" data-class="firstdata"
              value={first_row || ""}
              onChange={(e) => onChangeBomFirstRow(e.target.value)}/>
            {validator && validator.message(`First Data Row`, first_row, 'required|numeric|min:1,num')} 
          </div>
        </div>
        <div className="col-sm-3"/>
      </div>
    </>
  )
}

export default BomForm;